var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45869 0.140289C5.79537 -0.0467631 6.20481 -0.0467631 6.54148 0.140289L11.4061 2.84287C11.76 3.03949 11.9795 3.41253 11.9795 3.81739V9.18258C11.9795 9.58749 11.76 9.96052 11.4061 10.1571L6.54148 12.8597C6.20481 13.0467 5.79537 13.0468 5.45869 12.8597L0.594043 10.1571C0.240127 9.96052 0.0206299 9.58749 0.0206299 9.18258V3.81739C0.0206299 3.41253 0.240127 3.03949 0.594043 2.84287L5.45869 0.140289ZM6.04927 1.02622C6.01867 1.00922 5.98151 1.00922 5.9509 1.02622L1.08622 3.7288C1.05405 3.74667 1.0341 3.78059 1.0341 3.81739V9.18258C1.0341 9.2194 1.05405 9.25332 1.08622 9.27123L5.9509 11.9738C5.98151 11.9908 6.01867 11.9908 6.04927 11.9738L10.9139 9.27123C10.9461 9.25332 10.9661 9.2194 10.9661 9.18258V3.81739C10.9661 3.78059 10.9461 3.74667 10.9139 3.7288L6.04927 1.02622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79077 6.50008C2.79077 4.72763 4.22763 3.29077 6.00008 3.29077C7.77257 3.29077 9.2094 4.72763 9.2094 6.50008C9.2094 8.27257 7.77257 9.7094 6.00008 9.7094C4.22763 9.7094 2.79077 8.27257 2.79077 6.50008ZM6.00008 4.30424C4.78737 4.30424 3.80424 5.28737 3.80424 6.50008C3.80424 7.7128 4.78737 8.69593 6.00008 8.69593C7.2128 8.69593 8.19593 7.7128 8.19593 6.50008C8.19593 5.28737 7.2128 4.30424 6.00008 4.30424Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupIcon);
export default __webpack_public_path__ + "static/media/setupIcon.7c29e42640e47457e5d736fdd657fcad.svg";
export { ForwardRef as ReactComponent };